import useIsSearchPage from '@klv/hooks/useIsSearchPage';
import { useTranslation } from '@klv/hooks/useTranslation';

import * as styles from './styles/search.module.scss';

import type { Hit } from 'instantsearch.js';
import type { SendEventForHits } from 'instantsearch.js/es/lib/utils/createSendEventForHits';
import type { IMarketingSiteHit } from './types';

const MarketingSiteHit = ({ hit, sendEvent }: { hit: Hit<IMarketingSiteHit>; sendEvent: SendEventForHits; }) => {
  const title = hit?._highlightResult?.title?.value;
  const modifiedTitle = title?.replace(' - Klaviyo', '');
  const showDescription = useIsSearchPage();

  const { t } = useTranslation();

  let marketingSitePathPrefix = t('langCodes_pathPrefix');
  if (marketingSitePathPrefix) {
    marketingSitePathPrefix = '/' + marketingSitePathPrefix;
  }

  if (!title) return null;

  return (
    <div>
      <a
        className={styles.link}
        dangerouslySetInnerHTML={{ __html: modifiedTitle as string }}
        onClick={sendEvent}
        href={`https://www.klaviyo.com${marketingSitePathPrefix}${hit.uri}`}
      />
      {showDescription && (
        <div className={styles.snippet}
          dangerouslySetInnerHTML={{ __html: (hit?.content ? hit.content : '') }}
        />
      )}
    </div>
  );
};

export default MarketingSiteHit;
